
export default {
    Success : 200
}
